<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
$(document).ready(function(){
    function openDropdown() {
        const $ele = $('.dropdown-wrapper');
        if ($ele.length) {
            $(document).on('click','.dropdown-wrapper', function (e) {
                const $clicked = $(this);
                const isOpen = $clicked.hasClass('show');
                $ele.removeClass('show');
                if (!isOpen) {
                    $clicked.addClass('show');
                }
            })
        }
    }
    function triggerDropdown(params) {
        $('.dropdown-wrapper .option').on('click', function (e) {
            e.stopPropagation();
            const $ele = $('.dropdown-wrapper');
            const $clickedOption = $(this);
            const selectedValue = $clickedOption.attr('value');
    
            const $dropdownWrapper = $clickedOption.closest('.dropdown-wrapper'),
                  dropdownId = $dropdownWrapper.attr('id'),
                  $label = $dropdownWrapper.find('.option-choose');
          
            $ele.removeClass('show');
            console.log('selectedValue', selectedValue);
            $label.text(selectedValue);
          
            const textMatch = dropdownId.split('for-')[1];
            const $select = $(`#${textMatch}`);
          
            if (!$select.length) return;
            $select.val(selectedValue);
    
            $dropdownWrapper.find('.option').removeClass('selected');
    
            $clickedOption.addClass('selected');
          
            const selectElement = $select.get(0);
            
            const event = new Event('change', { bubbles: true });
            selectElement.dispatchEvent(event);
        });
    }
    if ($('body').hasClass('template-product')) {
        openDropdown();
        triggerDropdown();
    }
});